import { render } from "./Footer.vue?vue&type=template&id=828efdb6&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-828efdb6"

export default script